import React from 'react';

import { useServicesChartsDataContext } from '../../../Common/Services/hooks/useServicesChartsDataContext';
import Loading from '../../../../Dashboards/Common/Loading';
import { ServicesPerYearTotal } from '../../../Common/Services/charts/apex-charts/ServicesPerYearTotal';
import { ServicesPerMonthPerYearCompare } from '../../../Common/Services/charts/apex-charts/ServicesPerMonthPerYearCompare';

const GeneralResults = () => {
    const { isLoading } = useServicesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div className="charts-side-by-side-dashboards">
            <ServicesPerYearTotal height={400}  />
            <ServicesPerMonthPerYearCompare />
        </div>
    );
};

export default GeneralResults;
